export default "__VITE_ASSET__D8D1MtUQ__"